
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class FractalCloudsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (300 + layerIndex * 150) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing * 1.5);

        for (let x = x1; x <= x2; x += spacing * 1.5) {
            for (let y = y1; y <= y2; y += spacing * 1.5) {
                const r = spacing * (1 + this.pseudoRandom(x + y) * 2) * (config.parallaxScale || 1.0);
                
                const draw = () => {
                    const grad = ctx.createRadialGradient(x, y, 0, x, y, r);
                    const color = pc.color;
                    grad.addColorStop(0, color);
                    grad.addColorStop(1, 'transparent');
                    
                    ctx.fillStyle = grad;
                    ctx.beginPath();
                    ctx.arc(x, y, r, 0, Math.PI * 2);
                    ctx.fill();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
